import dialogActions from './dialogActions';
import dialogProps from '../../types/dialogProps';

import Contact from '../../Components/Contact';
import Demo from '../../Components/Demo';
import Invite from '../../Components/Invite';
import MobileNav from '../../Components/MobileNav';

type selectorIdType = string | '#portal' | null;
interface keyValuePairs {
    [key: string]: number
}

export interface reducerState {
    status: dialogActions,
    Render: ((props: dialogProps)=> JSX.Element) | null,
    callback?: ()=> void,
    delay: number,
    selectorId?: selectorIdType,
    data: keyValuePairs | null
}

interface reducerAction {
    type: dialogActions,
    dialogName?: keyof typeof dialogComponents,
    callback?: ()=> void,
    data?: keyValuePairs,
    delay?: number,
    selectorId?: selectorIdType,
}

// NOTE: When adding to this, make sure to update the dialogs enum in the Dialog component.
export const dialogComponents = {
    invite: Invite,
    contact: Contact,
    demo: Demo,
    mobileNav: MobileNav
};

export const initialState = {
    status: dialogActions.closed,
    Render: null,
    callback: undefined,
    data: null,
    delay: 1000,
    selector: null
};

const dialogReducer = (state: reducerState, action: reducerAction): reducerState => {
    switch (action.type) {
    case dialogActions.open:
        if (!action.dialogName || !dialogComponents[action.dialogName]) {
            return state;
        }
        return {
            status: dialogActions.open,
            Render: dialogComponents[action.dialogName],
            callback: action.callback || undefined,
            data: action.data || null,
            delay: action.delay || 300,
            selectorId: action.selectorId || '#portal'
        };
    case dialogActions.closing:
        return {
            ...state,
            status: dialogActions.closing
        };
    case dialogActions.closed:
        return {
            status: dialogActions.closed,
            Render: null,
            callback: undefined,
            data: null,
            delay: 300,
            selectorId: null
        };
    default:
        return state;
    }
};

export default dialogReducer;
